/**
 * @generated SignedSource<<2e225ddfbf26150be35c273225aa8040>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type GoalGroupHeader$data = {
  readonly displayName: string;
  readonly goal: {
    readonly score: number | null | undefined;
    readonly status: JiraGoalStatus | null | undefined;
  };
  readonly " $fragmentType": "GoalGroupHeader";
};
export type GoalGroupHeader$key = {
  readonly " $data"?: GoalGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoalGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GoalGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "status"
        },
        {
          "kind": "ScalarField",
          "name": "score"
        }
      ]
    }
  ],
  "type": "JiraJqlGoalsFieldValue"
};

(node as any).hash = "30c96208fa54dc40c8fbac3d2b4a9d25";

export default node;
